import axios from 'axios'
// 引入vuex
import store from '../store'
// 引入element-plus
import {
    ElMessage,
    ElMessageBox
} from 'element-plus'
// 引入logout方法
import {
    logOut
} from '../network/login'
// 常量
import {
    grant_type,
    client_id,
    client_secret
} from '../common/const.js'
// axios设置
axios.defaults.timeout = 600000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
axios.defaults.withCredentials = true; // 前端跨域传递cookie设置
// axios.defaults.responseType = 'blob'  
//   development本地
//   production 生成环境
//   test 测试环境 
console.log(process.env.NODE_ENV)

// 请求实例1：不需要token调用此实例
export function requestPublic(config) {
    const instance = axios.create({})
    instance.interceptors.request.use(config => {
        return config;
    })
    instance.interceptors.response.use(res => {
        console.log(res);
        const status = res.status;
        if (status === 200 || status === 301 || status === 302 || status === 303) {
            return res;
        }
    }, err => {
        if (err && err.response && err.response.status) {
            const status = err.response.status;
            if (status === 403) {
                ElMessageBox.alert('您没有权限:如需开通请联系直属上级！', {
                    confirmButtonText: "确定",
                  });
                return false;
            }

        } if (err && err.response && err.response.status && err.response.status == 400) {
            return err.response
        } else {
        ElMessageBox.alert(`专升本网后台管理系统(系统异常)${config.url},请将当前页全部截图然后联系技术人员处理!`, {
                confirmButtonText: "确定",
              });
        }

        return err;
    })

    return instance(config)
}

// 请求实例2：需要token调用此实例
// 使用 window 全局共享刷新状态，避免主应用与公共组件同时触发刷新导致 RefreshToken 冲突
if (!window.__refreshState) {
  window.__refreshState = {
    isRefreshing: false,
    refreshSubscribers: [],
    refreshFailed: false  // 刷新失败标记，防止 logOut 异步跳转期间重复触发刷新
  };
}
const refreshState = window.__refreshState;
export function request(config, isError = false) {
    const instance = axios.create({})
    // axios拦截器  添加token、添加提示
    instance.interceptors.request.use((config) => {
        var authTk = loadUserToken();
        // 日期选择转化
        const moment = require('moment')
        for (const k in config.data) {
            if (config.data[k] && config.data[k] instanceof Date) {
                config.data[k] = moment(config.data[k]).add(8, 'hours').local().toISOString()
            }
        }
        // console.log(authTk,'authTk')
        if (authTk) {
            config.headers.Authorization = 'Bearer' + ' ' + authTk;
            var currentUrl = config.url.toLowerCase();
            /*判断token是否将要过期,当前请求不是刷新请求 */
            if (isAccessTokenExpired() && currentUrl.indexOf('refreshToken'.toLowerCase()) == -1) {
                if (refreshState.refreshFailed) return config; // 已失败等待跳转，直接放行（不再刷新）
                if (!refreshState.isRefreshing) {
                    refreshState.isRefreshing = true;
                    getRefreshToken().then(function (res) {
                        var result = res && res.data.result ? res.data.result : '';
                        if (result && res.data.code ==1) {
                            let expiresTime = result.expires_in + new Date() / 1000
                            const tokenObj = {
                                AccessToken: result.access_token,
                                AccessExpiresIn: expiresTime,
                                RefreshToken: result.refresh_token
                            }
                            store.commit('updateToken', tokenObj)
                            // 将token存储到sessionStorage
                            sessionStorage.setItem('token', JSON.stringify(tokenObj));
                            config.headers.Authorization = 'Bearer' + ' ' + result.access_token;
                            onRrefreshed(result.access_token);
                        }else{
                            refreshState.refreshFailed = true;
                            logOut();
                            onRrefreshed(null);
                        }
                    }).catch(function (err) {
                        refreshState.refreshFailed = true;
                        logOut();
                        onRrefreshed(null);
                        return Promise.reject(err);
                    }).finally(() => {
                        refreshState.isRefreshing = false;
                    })
                }
                // 所有需要等待 token 刷新的请求都挂起
                return new Promise((resolve, reject) => {
                    subscribeTokenRefresh(token => {
                        if (token) {
                            config.headers.Authorization = 'Bearer ' + token;
                            resolve(config);
                        } else {
                            reject(new Error('Token刷新失败'));
                        }
                    });
                });
            } else {
                return config;
            }
        } else {
            return config;
        }
    }, (err) => {
        return err
    })
    // 响应器
    instance.interceptors.response.use((res) => {
        if (res.status === 200 || res.status === 301 || res.status === 302 || res.status === 303) {
            if(res.data.code==403){
                ElMessageBox.alert(res.data.message);
                return Promise.reject()
            }
            return res.data;
        }
        return res
    }, (err) => {
        if (err && err.response && err.response.status) {
            const status = err.response.status;
            console.log(err,'err')
            if (status === 401) {
                console.log('401')
                    var errConfig = err.config; //失败的请求头
                    // 如果已经是重试请求再次 401，直接登出，不再刷新，防止死循环
                    if (errConfig._retry) {
                        logOut();
                        return Promise.reject(err);
                    }
                    // 如果已知刷新失败（正在跳转登录页），直接拒绝不再尝试
                    if (refreshState.refreshFailed) {
                        return Promise.reject(err);
                    }
                    errConfig._retry = true;
                    var refreshToken = JSON.parse(sessionStorage.getItem('token'))?.RefreshToken || store.state.token.RefreshToken;
                    if (refreshToken) {
                        // 将当前失败的请求加入等待队列，等 token 刷新后重试
                        var retryRequest = new Promise((resolve, reject) => {
                            subscribeTokenRefresh(token => {
                                if (token) {
                                    errConfig.headers.Authorization = 'Bearer ' + token;
                                    resolve(instance(errConfig));
                                } else {
                                    reject(new Error('Token刷新失败'));
                                }
                            });
                        });
                        if (!refreshState.isRefreshing) {
                            refreshState.isRefreshing = true;
                            getRefreshToken().then(function (res) {
                                console.log(res,'res')                               
                                var result = res && res.data?.result ? res.data.result : '';
                                if (result && res.data.code == 1) {
                                    let expiresTime = result.expires_in + new Date() / 1000
                                    store.commit('updateToken', {
                                        AccessToken: result.access_token,
                                        RefreshToken: result.refresh_token,
                                        AccessExpiresIn: expiresTime,
                                    })
                                    // 将token存储到sessionStorage
                                    sessionStorage.setItem('token', JSON.stringify({
                                        AccessToken: result.access_token,
                                        RefreshToken: result.refresh_token,
                                        AccessExpiresIn: expiresTime,
                                    }));
                                    onRrefreshed(result.access_token);
                                } else {
                                    refreshState.refreshFailed = true;
                                    logOut();
                                    onRrefreshed(null);
                                }
                            }).catch(function (err) {
                                refreshState.refreshFailed = true;
                                logOut(); //跳转登录页
                                onRrefreshed(null);
                                return Promise.reject(err);
                            }).finally(function () {
                                refreshState.isRefreshing = false;
                            })
                        }
                        return retryRequest;
                    } else {
                        logOut(); //跳转登录页
                    }
                // } else {
                //     // logOut(); //跳转登录页
                // }
            } else if (status === 403) {
                if (!isError) {
                    ElMessageBox.alert('您没有权限:如需开通请联系直属上级！');
                  }
                
            }else{
                ElMessageBox.alert(config.url+","+err.message+","+'请将当前页全部截图然后联系技术人员处理');
            }
        }
        // 接口报403时，不反悔错误信息
        const status = err?.response?.status;
        if (!isError) {
            if (status != 403) return err;
          } else {
            return err;
          }
    })
     // 4. 返回实例
  return instance(config)
}
// 获取AccessToken
function loadUserToken() {
    
    var accessToken = JSON.parse(sessionStorage.getItem('token'))?.AccessToken || store.state.token?.AccessToken || '';
    return accessToken;
}
// 判断AccessToken是否过期
function isAccessTokenExpired() {
    var accessToken = JSON.parse(sessionStorage.getItem('token'))?.AccessToken || store.state.token?.AccessToken;
    var expires_in = JSON.parse(sessionStorage.getItem('token'))?.AccessExpiresIn || store.state.token.AccessExpiresIn;
    if (!accessToken || !expires_in) return false;
    var currentTime = Date.parse(new Date()) / 1000;
    var expiresTime = expires_in;
    // 600秒后即将过期,true则不需要刷新
    return expiresTime - currentTime <= 60
}
// 请求新AccessToken
function getRefreshToken() {
    const refreshToken = JSON.parse(sessionStorage.getItem('token'))?.RefreshToken || store.state.token.RefreshToken;
    let params = new URLSearchParams();
    params.append('grant_type', 'refresh_token');
    params.append('client_id', 'hbzsb-admin');      // 与公共组件保持一致，使用升本中心统一客户端凭据
    params.append('client_secret', 'zsb.web.secret'); // 与公共组件保持一致
    params.append('refresh_token', refreshToken);
    
    return requestPublic({
        url: '/api1/connect/token',
        method: 'post',
        data: params
    })
}

function subscribeTokenRefresh(cb) {
    refreshState.refreshSubscribers.push(cb);
}

// 数组中的请求得到新的token之后自执行，用新的token去请求数据
function onRrefreshed(token) {
    refreshState.refreshSubscribers.map(function (cb) {
        return cb(token);
    })
    refreshState.refreshSubscribers = [];
    // isRefreshing 由 finally 统一重置，此处不重置，避免订阅者回调执行期间提前开放刷新锁
}
// 存储token  24小时
function isDayToken() {
    let token = store.state.token || JSON.parse(sessionStorage.getItem('token'));
    let accessToken = token.AccessToken;
    let expires_in = token.AccessExpiresIn;
    if (!accessToken || !expires_in) return false;
    let currentTime = Date.parse(new Date()) / 1000;
    let expiresTime = expires_in;
    // 24小时后删除Token
    if (currentTime - expiresTime > 86400) {
        sessionStorage.removeItem('token')
    }
}